import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import React, { useMemo, useState, ReactNode } from 'react';

const SelectDropdown = ({
  options,
  value,
  placeholder,
  setValue,
  label,
  hasSearch,
  subAction,
  disabled,
  required
}: {
  options: { id: string; name: string }[];
  value: string | undefined;
  placeholder: string;
  setValue: (arg0: any) => void;
  label?: string;
  hasSearch?: boolean;
  subAction?: ReactNode;
  disabled?: boolean;
  required?: boolean;
}) => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState('');

  const filteredOptions = useMemo(() => {
    if (!hasSearch || !search) return options;
    return options?.filter((o) => o.name.toLowerCase().includes(search.toLowerCase()));
  }, [options, search]);

  return (
    <Dropdown
      disabled={disabled}
      visible={show}
      onClickOutside={() => setShow(false)}
      className='w-full'
      content={
        <div onClick={() => setShow(!show)}>
          <p className='my-2 font-medium'>
            {label} {required && <span className='text-red-5'>*</span>}
          </p>
          <div className='border-b-2 border-b-[#D5D6D7] bg-[#FAFAFA] rounded-none h-[46px] text-sm flex items-center px-4 justify-between cursor-pointer'>
            {hasSearch ? (
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className='w-full bg-transparent outline-none text-base font-medium [&:placeholder]:text-gray-4 capitalize'
                placeholder={placeholder}
              />
            ) : (
              <p className='text-base font-medium capitalize'>
                {value ? (
                  value
                ) : (
                  <span className='text-base text-gray-4 font-medium'>{placeholder}</span>
                )}
              </p>
            )}
            <div className='text-gray-4'>
              <ArrowDownIcon />
            </div>
          </div>
          {subAction}
        </div>
      }>
      <DropdownList>
        {filteredOptions?.map((option) => (
          <DropdownItem
            key={option.id}
            onClick={() => {
              setValue(option);
              setSearch(option.name);
              setShow(!setShow);
            }}>
            <p className='capitalize'>{option.name}</p>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default SelectDropdown;
